import produce from "immer";
import IOrdersReducer from "models/IOrdersReducer";
import { actionTypes } from "./actions";
import { orderSorting as defaultSorting } from "constants/sorting";

const initialState: IOrdersReducer = {
  isLoading: false,
  isLoaded: false,
  items: [],
  meta: {
    defaultSorting
  },
  orderLines: [],
  orderDeliveries: [],
  orderReceiptsReturns: [],
  orderInvoices: [],
  orderVersions: [],
  currentItem: null,
  error: null,
  statusOptions: [],
  typeOptions: []
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, draftState => {
    switch (action.type) {
      case actionTypes.GET_ORDERS_SUCCESS:
        draftState.items = action.payload;
        draftState.meta = action.meta;
        break;
      case actionTypes.GET_ORDERS_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.GET_ORDER_REQUEST:
        draftState.currentItem = null;
        break;
      case actionTypes.GET_ORDER_SUCCESS:
        draftState.currentItem = action.payload;
        break;
      case actionTypes.GET_ORDER_LINES_REQUEST:
        draftState.isLoading = true;
        break;
      case actionTypes.GET_ORDER_LINES_SUCCESS:
        draftState.isLoading = false;
        draftState.isLoaded = true;
        draftState.orderLines = action.payload;
        break;
      case actionTypes.GET_ORDER_DELIVERIES_REQUEST:
        draftState.isLoading = true;
        break;
      case actionTypes.GET_ORDER_DELIVERIES_SUCCESS:
        draftState.isLoading = false;
        draftState.isLoaded = true;
        draftState.orderDeliveries = action.payload;
        break;
      case actionTypes.GET_ORDER_RECEIPTS_RETURNS_REQUEST:
        draftState.isLoading = true;
        break;
      case actionTypes.GET_ORDER_RECEIPTS_RETURNS_SUCCESS:
        draftState.isLoading = false;
        draftState.isLoaded = true;
        draftState.orderReceiptsReturns = action.payload;
        break;
      case actionTypes.GET_ORDER_INVOICES_REQUEST:
        draftState.isLoading = true;
        break;
      case actionTypes.GET_ORDER_INVOICES_SUCCESS:
        draftState.isLoading = false;
        draftState.isLoaded = true;
        draftState.orderInvoices = action.payload;
        break;
      case actionTypes.GET_ORDER_VERSIONS_REQUEST:
        draftState.isLoading = true;
        break;
      case actionTypes.GET_ORDER_VERSIONS_SUCCESS:
        draftState.isLoading = false;
        draftState.isLoaded = true;
        draftState.orderVersions = action.payload;
        break;
      case actionTypes.MARK_ORDER_LINE_DELIVERED_REQUEST:
        draftState.isLoading = true;
        break;
      case actionTypes.GET_ORDER_SELECT_OPTIONS_REQUEST:
        draftState.statusOptions = [];
        draftState.typeOptions = [];
        break;
      case actionTypes.GET_ORDER_SELECT_OPTIONS_SUCCESS:
        draftState.statusOptions = action.payload.statusOptions;
        draftState.typeOptions = action.payload.typeOptions;
        break;
    }
  });
